module.exports = __webpack_public_path__ + "img/bell_4.2fb4b021.jpg";